import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const _cmp = (a, b) => (a || "").localeCompare(b || "", undefined, { sensitivity: "base" });
export const byFirstName = (list) => [...(list || [])].sort((a, b) =>
  _cmp(a.first_name ?? a.name, b.first_name ?? b.name) || _cmp(a.last_name, b.last_name));
